<template>
  <div class="rts" ref="root" @click="onRootClick">
    <button type="button"
      :id="id"
      class="rts-toggle"
      :class="{ 'rts-placeholder': !value || !value.value }"
      aria-haspopup="listbox"
      :aria-expanded="open ? 'true' : 'false'"
      @keydown="onKeydown">
      {{ value && value.value ? value.text : placeholder }}
    </button>

    <ul v-if="open" ref="list" class="rts-list" role="listbox">
      <li v-for="(opt, idx) in options"
        :key="opt.code"
        role="option"
        class="rts-option"
        :class="{ active: idx === activeIndex, selected: isSelected(opt) }"
        :aria-selected="isSelected(opt) ? 'true' : 'false'"
        @mouseenter="activeIndex = idx"
        @mouseleave="activeIndex = -1"
        @click="select(opt)">
        {{ opt.title }}
        <div v-if="idx === activeIndex && descMap[opt.code]" class="rts-tooltip" v-text="descMap[opt.code].trim()"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ReportTypeSelect',
  props: {
    value: { type: Object, default: () => ({}) },
    options: { type: Array, default: () => [] },
    descMap: { type: Object, default: () => ({}) },
    placeholder: { type: String, default: '' },
    id: { type: String, default: '' }
  },
  data () {
    return {
      open: false,
      activeIndex: -1
    }
  },
  mounted () {
    document.addEventListener('click', this.onOutsideClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onOutsideClick)
  },
  methods: {
    isSelected (opt) {
      return !!this.value && this.value.value === opt.code
    },
    onRootClick (e) {
      if (this.$refs.list && this.$refs.list.contains(e.target)) {
        return
      }
      this.open = !this.open
      this.activeIndex = -1
    },
    close () {
      this.open = false
      this.activeIndex = -1
    },
    select (opt) {
      this.$emit('input', { value: opt.code, text: opt.title })
      this.$emit('change', { value: opt.code, text: opt.title })
      this.close()
    },
    onOutsideClick (e) {
      if (this.open && !this.$refs.root.contains(e.target)) {
        this.close()
      }
    },
    onKeydown (e) {
      const len = this.options.length
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault()
        if (!this.open) {
          this.open = true
        }
        const step = e.key === 'ArrowDown' ? 1 : -1
        this.activeIndex = (this.activeIndex + step + len) % len
      } else if (e.key === 'Enter' && this.open && this.activeIndex > -1) {
        e.preventDefault()
        this.select(this.options[this.activeIndex])
      } else if (e.key === 'Escape') {
        this.close()
      }
    }
  }
}
</script>

<style scoped>
.rts {
  position: relative;
  cursor: pointer;
}
.rts::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 0.3rem;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: -0.35rem;
  border-right: 2px solid #000000;
  border-bottom: 2px solid #000000;
  transform: rotate(45deg);
  pointer-events: none;
}
.rts-toggle {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 1.5em;
  margin: 0;
  padding: 0 24px 0 3px;
  border: 0;
  background: transparent;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
}
.rts-toggle:focus {
  outline: none;
}
.rts:focus-within {
  outline: none;
  outline-offset: -1px;
}
.rts-placeholder {
  color: #FEFEFE;
}
.rts-list {
  position: absolute;
  top: 100%;
  left: -1px;
  right: -1px;
  z-index: 1000;
  margin: 0;
  padding-left: 2px;
  list-style: none;
  background: #fff;
  border: 1px solid #ccc;
  cursor: default;
}
.rts-option {
  position: relative;
  padding: 5px 16px;
  line-height: 1.3;
  min-height: 1.3em;
  cursor: pointer;
}
.rts-option.active {
  background: Highlight;
  color: HighlightText;
}
.rts-option.selected {
  font-weight: 600;
}
.rts-tooltip {
  position: absolute;
  top: 0;
  left: calc(100% + 8px);
  width: 280px;
  padding: 5px 12px;
  background: #CCCCCC;
  color: #000;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 4px;
  white-space: pre-line;
  z-index: 1001;
  pointer-events: none;
}
.default-select.form-select {
  line-height: 35px;
}
@media (max-width: 768px) {
  .rts-tooltip {
    top: 100%;
    left: 0;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReportTypeSelect.vue